import { render } from "./AssociateTrailerSuccess.vue?vue&type=template&id=7b8e1908&scoped=true&ts=true"
import script from "./AssociateTrailerSuccess.vue?vue&type=script&lang=ts"
export * from "./AssociateTrailerSuccess.vue?vue&type=script&lang=ts"

import "./AssociateTrailerSuccess.vue?vue&type=style&index=0&id=7b8e1908&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b8e1908"]])

export default __exports__